"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const ReducerRegistry_1 = require("./ReducerRegistry");
const cw_website_events_1 = require("@dialogexe/cw-website-events");
const redux_saga_1 = require("redux-saga");
const sagas_1 = require("./sagas");
const reducer_1 = require("./events/reducer");
const reducer_2 = require("./userProfile/reducer");
const reducer_3 = require("./watchList/reducer");
const reducer_4 = require("./movie/reducer");
const reducer_5 = require("./tickets/reducer");
const reducer_6 = require("./reviews/reducer");
ReducerRegistry_1.default.register('userProfile', reducer_2.reducer);
ReducerRegistry_1.default.register('watchList', reducer_3.reducer);
ReducerRegistry_1.default.register('movie', reducer_4.reducer);
ReducerRegistry_1.default.register('tickets', reducer_5.reducer);
ReducerRegistry_1.default.register('reviews', reducer_6.reducer);
ReducerRegistry_1.default.register('events', reducer_1.reducer);
exports.createStore = () => {
    const sagaMiddleware = redux_saga_1.default();
    let reducers = () => null;
    if (Object.keys(ReducerRegistry_1.default.reducers).length > 0) {
        reducers = redux_1.combineReducers(ReducerRegistry_1.default.reducers);
    }
    const store = redux_1.createStore(reducers, composeEnhancers(redux_1.applyMiddleware(sagaMiddleware, cw_website_events_1.middleware)));
    sagaMiddleware.run(sagas_1.default);
    ReducerRegistry_1.default.listener = (reducers) => {
        store.replaceReducer(redux_1.combineReducers(reducers));
    };
    return store;
};
const composeEnhancers = typeof window === 'object' && process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) :
    redux_1.compose;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/createStore.ts